module.exports = __webpack_public_path__ + "img/affiche.24577e1e.png";